import React from 'react';
import { durationCalculate,runTypePick,calculateActivitySpeed,AerobicSpeedCalculate,BaseSpeedCalculate,IntervalSpeedCalculate,distanceEstimation} from '../../helperFunctions/runningProgramFunctions';
import {metricDistance,convertMetrics, metricSpeed,metric} from '../../helperFunctions/measurementSystem'


const activityStyle = (type) =>{
    if (type === 'Aerobic II'){
        return 'text-success'
    }
    if (type === 'Base'){
        return 'text-info'
    }
    if (type === 'Long run'){
        return 'text-info'
    }
    if (type === 'Tempo'){
        return 'text-warning'
    }
    if (type === 'Interval'){
        return 'text-danger'
    }
    else{
        return 'text-success'
    }
}

function SingleRun({activity,user,measurementSystem}){
    
    if (activity.type === 'Interval'){
        const IntervalFast = activity.tss/2
        const IntervalSlow = activity.tss/2
        const fastDuration = durationCalculate(IntervalFast,'Interval',user)
        const slowDuration = durationCalculate(IntervalSlow,'Base',user)

        var speedFast = calculateActivitySpeed(fastDuration,'Interval',user)
        var speedSlow = calculateActivitySpeed(slowDuration,'Base',user)


        var est_distanceFast = distanceEstimation (fastDuration,speedFast)
        var est_distanceSlow = distanceEstimation (slowDuration,speedSlow)
        var distanceTotal = parseInt(est_distanceSlow) + parseInt(est_distanceFast)

        speedFast = convertMetrics(speedFast,measurementSystem)
        speedSlow = convertMetrics(speedSlow,measurementSystem)
        distanceTotal = metricDistance(distanceTotal/1000,measurementSystem)

        return(
            <tbody style={{color:'white'}}>
                <td className={activityStyle(activity.type)}>
                    {activity.type} 1-3
                </td>
                <td>
                    <span className="text-info">{Number(fastDuration).toFixed(0)}</span><span style={{color:'rgb(200,180,255)',fontSize:'7px'}}> minutes</span>   <span className={activityStyle(activity.type)}>{speedFast}</span><span style={{color:'rgb(200,180,255)',fontSize:'9px'}}> {metricSpeed(measurementSystem)} </span>
                    &
                    <span className="text-info"> {Number(slowDuration).toFixed(0)}</span><span style={{color:'rgb(200,180,255)',fontSize:'7px'}}> minutes</span>   <span className='text-info'>{speedSlow}</span><span style={{color:'rgb(200,180,255)',fontSize:'9px'}}> {metricSpeed(measurementSystem)}</span>
                </td>
                <td>
                {distanceTotal} {metric(measurementSystem)}
                </td>
                <td className='text-warning tss' >
                {activity.tss.toFixed(0)}
                </td>
            </tbody>
        )
    }
    if (activity.type=='Aerobic I'){
        return(
            <tbody style={{color:'white'}}>
                <td style={{color:'rgb(80,200,150'}}>
                    {activity.type}
                </td>
                <td>
                    <span className="text-info">{Number(activity.duration).toFixed(0)}</span><span style={{color:'rgb(200,180,255)',fontSize:'7px'}}> min</span>   <span className={activityStyle(activity.type)}>{convertMetrics(activity.speed,measurementSystem)}</span><span style={{color:'rgb(200,180,255)',fontSize:'9px'}}> {metricSpeed(measurementSystem)}</span>
                </td>
                <td>
                {metricDistance(activity.est_distance/1000,measurementSystem)} {metric(measurementSystem)}
                </td>
                <td className='text-warning'>
                {activity.tss.toFixed(0)}
                </td>
            </tbody>
        )
    }
    return(
        <tbody style={{color:'white'}}>
            <td className={activityStyle(activity.type)}>
                {activity.type}
            </td>
            <td>
                <span className="text-info">{Number(activity.duration).toFixed(0)}</span><span style={{color:'rgb(200,180,255)',fontSize:'7px'}}> min</span>   <span className={activityStyle(activity.type)}>{convertMetrics(activity.speed,measurementSystem)}</span><span style={{color:'rgb(200,180,255)',fontSize:'9px'}}> {metricSpeed(measurementSystem)}</span>
            </td>
            <td>
            {metricDistance(activity.est_distance/1000,measurementSystem)} {metric(measurementSystem)}
            </td>
            <td className='text-warning'>
            {activity.tss.toFixed(0)}
            </td>
        </tbody>
    )
}

export default SingleRun;